import { REFRESH_COMPONENT } from "./RefreshComponentActionTypes";
import { initialState } from "../initialState";

const refreshComponentReducer = (state = initialState, action) => {
	switch (action.type) {
		case REFRESH_COMPONENT:
			return {
				...state,
				refreshComponent: action.payload,
			};
		default:
			return state;
	}
};

export default refreshComponentReducer;
